var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-echarts"},[_c('img',{attrs:{"src":require("../../../assets/images/no-data.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('common.empty')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }